import type { ReactNode } from 'react';

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="text-[11px] font-bold tracking-[0.18em] text-muted">
      {children}
    </div>
  );
}
